import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import AppState from '../../state';
import { rudderTrackGroup } from '@webapp/utils/rudderstack/init';
import { SetActiveLabel } from '@webapp/store/record-labels/action-creators';
import { SET_ACTIVE_LABEL } from '@webapp/store/record-labels/actions';
import { ListSubscriptionsSuccess } from '@webapp/store/subscription-manager/action-creators';
import { LIST_SUBSCRIPTIONS_SUCCESS } from '@webapp/store/subscription-manager/actions';
import { getUserReferrer } from '@webapp/store/auth/selectors';

export const identifyRudderstackArtistEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, ListSubscriptionsSuccess | SetActiveLabel>(
      LIST_SUBSCRIPTIONS_SUCCESS,
      SET_ACTIVE_LABEL
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active),
    map(([_, state]) => {
      const artistSubscriptions =
        state.subscriptionManager?.summary?.artists.find(
          (artist) => artist.id === state.artist.active?.id
        )?.subscriptions ?? [];

      const subscription = artistSubscriptions.reduce((acc, item) => {
        let plan;
        if (['distribution', 'trac-pro'].includes(item.type)) {
          plan = item.plan.toLowerCase().includes('pro') ? 'pro' : 'beginner';
          acc[item.type] = plan;
        }

        if (item.type === 'merch') {
          plan = item.plan.toLowerCase().includes('pro') ? 'pro' : 'beginner';
          acc[item.type] = plan;
        }
        return acc;
      }, {});

      if (state.artist.active) {
        rudderTrackGroup(state.artist.active.id, {
          name: state.artist.active?.name,
          roster: {
            id: state.recordLabels.active?.id,
            name: state.recordLabels.active?.name,
          },
          role: state.artist.active?.role,
          subscription,
          referrer: getUserReferrer(state),
          enabled: state.artist.active?.enabled,
          inWatchlist: state.artist.active?.inWatchlist,
        });
      }
    }),
    filter(() => false)
  );
